module.exports = __webpack_public_path__ + "static/media/cancelSvg.10fdd3da.svg";